import { TRACKING } from "@/data/constants";
import type { AnalyticsEvent, DeepReadonly } from "@/types";

// ========== ANALYTICS UTILITIES ==========

declare global {
  interface Window {
    gtag?: (..._args: unknown[]) => void;
  }
}

/**
 * Track a custom event with Google Analytics
 */
export const trackEvent = (event: DeepReadonly<AnalyticsEvent>): void => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", event.action, {
      event_category: event.category,
      event_label: event.label,
      value: event.value,
    });
  }
};

/**
 * Track page view with Google Analytics
 */
export const trackPageView = (pagePath: string, pageName: string): void => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("config", TRACKING.GA_ID, {
      page_path: pagePath,
      page_name: pageName,
      page_url: window.location.href,
      device_type: window.innerWidth < 768 ? "mobile" : "desktop",
    });
  }
};

// ========== COMMON EVENT TRACKERS ==========

export const trackCalendlyClick = (source: string): void => {
  trackEvent({
    action: "calendly_click",
    category: "engagement",
    label: source,
  });
};

